import React from 'react';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';

const buildAccountText = (accountNumber, accountName) => {
  if (accountName && accountNumber) {
    return `${ accountNumber } - ${ accountName }`;
  }
  if (accountNumber) {
    return accountNumber;
  }
  if (accountName) {
    return accountName;
  }
  return 'N/A';
};

// eslint-disable-next-line import/prefer-default-export
export const AccountLinkCellRenderer = ({
  data: form
}) => {
  const link = form && `/account/${ form.accountId }`;
  return (
    <div className="form-action-btn-group">
      { form && form.accountId && <span className="text-ellipsis">
        <Link to={ link } className="text-bold" title={ buildAccountText(form.accountNumber, form.accountName) }>{ buildAccountText(form.accountNumber, form.accountName) }</Link>
      </span> }
      { (!form || !form.accountId) && <span>N/A</span> }
    </div>
  );
};

AccountLinkCellRenderer.propTypes = {
  data: PropTypes.shape({}),
  context: PropTypes.shape({})
};

AccountLinkCellRenderer.defaultProps = {
  context: {},
  data: {}
};
